// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Z1Kh","colBig":"styles_colBig__26dDx","colSmall":"styles_colSmall__bkA8k"};